import { Inject, Injectable } from '@angular/core';
import { CrudFluxService } from 'src/app/core/services/crud-flux.service';
import { WATER_SUPPLY_COMPANY_ENDPOINT, WATER_SUPPLY_COMPANY_QUERY_SERVICE_INSTANCE } from '../water-supply.config';
import { QueryService } from 'src/app/core/services/query.service';
import { ApiFluxService } from 'src/app/core/services/api-flux.service';
import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';
import { map } from 'rxjs';
import { IPageEvent } from 'src/app/core/models/paginator.model';
import { ApiService } from 'src/app/core/services/api.service';
import { CrudService } from 'src/app/core/services/crud.service';

@Injectable({
  providedIn: 'root'
})
export class WaterSupplyCompanyService extends CrudService<any> {

  constructor(
           @Inject(WATER_SUPPLY_COMPANY_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<any>,
           public readonly apiService:ApiService,
           protected  override readonly snackbar : SnackbarService
         ) {
           super(WATER_SUPPLY_COMPANY_ENDPOINT, apiService, snackbar);
          }

    getAllWaterSupplyCompanies() {
      return this.apiService.get(WATER_SUPPLY_COMPANY_ENDPOINT);
    }

    getAllFiltered(parameter : IPageEvent, searchData?:any, filters?: Record<string, any>){
      const stringSearch = searchData || ''
      let queryParams: string[] = [];
      if(filters){
        Object.keys(filters).forEach(key => {
          if (filters[key]) {
            let filterValue = '';
            if(key.includes('_from')){
              filterValue = `${key.split('_from')[0]}||gte||${filters[key]}`;
            }else if(key.includes('_to')){
              filterValue = `${key.split('_to')[0]}||lte||${filters[key]}`;
            }else{
              filterValue = `${key}||eq||${filters[key]}`
            }
            queryParams.push(`filter=${encodeURIComponent(filterValue)}`);
          }
        });
      }
      queryParams.push(`page=${parameter.pageIndex}`);
      queryParams.push(`limit=${parameter.pageSize}`);
      if(searchData) queryParams.push(`search=${stringSearch}`);
      const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
      return this.apiService.get(WATER_SUPPLY_COMPANY_ENDPOINT + queryString)

    }

    getWaterSupplyCompany(id : number | string){
      return this.apiService.get(`${WATER_SUPPLY_COMPANY_ENDPOINT}/${id}`)
    }
}
